import Scroller from './view'

export default Scroller
